<template>
  <div id="uniforms">
    <Header
      :page="'uniforms'"
      :title_one="'uniforms'"
      :action_one="'add'"
      @uniformForm="uniformForm()"
    ></Header>
    <!-- <Header :page="'uniforms'" :title_one="'uniforms'"></Header> -->
    <!-- {{ $t('uniforms.label') }} -->

    <h5 class="subtitle">{{ $t("descriptions.club_uniforms") }}</h5>
    <div class="row team-equipment">
      <div
        class="equipment"
        v-for="uniform in uniforms"
        v-bind:key="uniform.id"
      >
        <div class="cart">
          <Equipment
            class="equip"
            :equipment="uniform"
            :is_preview="true"
            :sport="user.event_sport"
          ></Equipment>
          <div class="uniform-actions">
            <button class="btn" v-on:click="openDialog(uniform.id)">
              {{ $t("delete") }}
            </button>
            <button class="btn" v-on:click="uniformForm(uniform)">
              {{ $t("edit") }}
            </button>
          </div>
        </div>
        <div class="description">
          <div class="row">
            <div class="title">{{ $t("params.local_uniform") }}</div>
            <div class="list" v-if="uniform.assigned_primary.length > 0">
              <ul>
                <li v-for="id in uniform.assigned_primary" :key="id">
                  <template v-if="club.teams[id]">
                    {{
                      club.teams[id].name +
                        " " +
                        club.teams[id].category.max_age
                    }}
                  </template>
                </li>
              </ul>
            </div>
            <div class="list" v-else>
              {{
                $t("descriptions.no_assigned", {
                  s: $t("params.visit_uniform")
                })
              }}
            </div>
          </div>
          <div class="row">
            <div class="title">{{ $t("params.visit_uniform") }}</div>
            <div class="list" v-if="uniform.assigned_secondary.length > 0">
              <ul>
                <li v-for="id in uniform.assigned_secondary" :key="id">
                  <template v-if="club.teams[id]">
                    {{
                      club.teams[id].name +
                        " " +
                        club.teams[id].category.max_age
                    }}
                  </template>
                </li>
              </ul>
            </div>
            <div class="list" v-else>
              {{
                $t("descriptions.no_assigned", {
                  s: $t("params.visit_uniform")
                })
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="equipment" id="add-equipment" v-on:click="uniformForm()">
        <div class="cart">
          <Equipment
            class="equip"
            :equipment="{}"
            :is_preview="true"
            :sport="user.event_sport"
          ></Equipment>
          <div class="uniform-actions">
            <button class="btn" v-on:click="uniformForm()">
              {{ $t("add") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <ConfirmPopup
      @close="cancel()"
      @confirm="deleteUniform()"
      :dialog="dialog"
    ></ConfirmPopup>

    <v-dialog
      v-model="dialog2"
      :scrollable="true"
      z-index="999999"
      width="900"
      height="700px"
      style="overflow: hidden !important"
      class="modal"
      data-app
    >
      <div id="uniform_form">
        <div class="body">
          <h2 v-if="type == 1">{{ $t("params.new_uniform") }}</h2>
          <h2 v-else>{{ $t("params.edit_uniform") }}</h2>
          <Equipment
            class="equipment"
            :equipment="uniform"
            :error="error.uniform"
            :sport="user.event_sport"
          ></Equipment>
        </div>
        <div class="buttons">
          <div class="btn" v-on:click="cancel()" id="cancel">
            {{ $t("cancel") }}
          </div>
          <div
            v-if="type == 1"
            v-on:click="validateUniform()"
            class="btn"
            id="add"
          >
            {{ $t("add") }}
          </div>
          <div v-else v-on:click="validateUniform()" class="btn" id="add">
            {{ $t("save") }}
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Equipment from "@/components/ui/Equipment.vue";
import Header from "@/components/layout/Header";
import ConfirmPopup from "@/components/ui/ConfirmPopup.vue";

export default {
  name: "Uniforms",
  components: {
    i18n,
    Equipment,
    Header,
    ConfirmPopup
  },
  data() {
    return {
      club: {},
      uniforms: {},
      dialog: false, // open dialog 1 (delete uniform)
      dialog2: false, // open dialog 2 (add/delete uniform)
      uniform_to_delete: 0, // id uniform to delete
      uniform: {
        // copy from uniform to edit or add
        primary_color: "",
        secondary_color: "",
        type: "",
        pants_color: "",
        socks_color: ""
      },
      error: {
        uniform: {
          primary_color: false,
          secondary_color: false,
          type: false,
          pants_color: false,
          socks_color: false
        }
      },
      type: 1 // 1 = add, 2 = edit
    };
  },

  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    }
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      // check if user isn't admin
      if (!this.user.admin) {
        this.$router.push({ name: "home" });
      }
      var self = this;
      // save page
      this.$store
        .dispatch("club/loadClubEvent", {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        })
        .then(function() {
          self.club = self.$store.getters["club/getClub"];
          // self.uniforms = self.club.uniforms
          var aUniforms = [];
          for (var i in self.club.uniforms) {
            // if(self.club.uniforms[i].club_uniform == "1"){
            // init assigned teams
            self.club.uniforms[i].assigned_primary = [];
            self.club.uniforms[i].assigned_secondary = [];
            // get assigned teams
            for (var n in self.club.teams) {
              // check for teams if has this equipment assigned in the local equipment
              if (
                self.club.teams[n].local_uniform != null &&
                self.club.teams[n].local_uniform.id == self.club.uniforms[i].id
              ) {
                self.club.uniforms[i].assigned_primary.push(
                  self.club.teams[n].id
                );
              }
              // check for teams if has this equipemnt assigned in the away equipment
              if (
                self.club.teams[n].away_uniform != null &&
                self.club.teams[n].away_uniform.id == self.club.uniforms[i].id
              ) {
                self.club.uniforms[i].assigned_secondary.push(
                  self.club.teams[n].id
                );
              }
            }
            // save uniform
            aUniforms.push(self.club.uniforms[i]);
            // }
          }
          // save uniforms
          self.uniforms = aUniforms;
        });
    },

    uniformForm(uniform = false) {
      if (uniform) {
        this.type = 2; // edit
        this.uniform = JSON.parse(JSON.stringify(uniform)); // clone object
      } else {
        (this.uniform = {
          primary_color: "",
          secondary_color: "",
          type: "",
          pants_color: "",
          socks_color: ""
        }),
          (this.type = 1);
      }
      this.dialog2 = true;
    },

    openDialog(id) {
      this.dialog = true;
      this.uniform_to_delete = id;
    },

    cancel() {
      this.dialog = false;
      this.dialog2 = false;
      this.uniform_to_delete = 0;
      (this.uniform = {
        primary_color: "",
        secondary_color: "",
        type: "",
        pants_color: "",
        socks_color: ""
      }),
        (this.type = 1);
    },

    deleteUniform() {
      this.dialog = false;
      var self = this;
      this.$store
        .dispatch("club/deleteUniform", {
          club_id: this.club.id,
          uniform_id: this.uniform_to_delete
        })
        .then(function() {
          self.load();
        });
    },

    validateUniform() {
      var validate = true;

      // validate primary_color
      if (isEmpty(this.uniform.primary_color)) {
        this.error.uniform.primary_color = true;
        validate = false;
      } else {
        this.error.uniform.primary_color = false;
      }

      // validate type
      if (isEmpty(this.uniform.type)) {
        this.error.uniform.type = true;
        validate = false;
      } else {
        this.error.uniform.type = false;
      }

      // validate secondary_color
      if (
        isEmpty(this.uniform.secondary_color) &&
        this.uniform.type != "one_colour"
      ) {
        this.error.uniform.secondary_color = true;
        validate = false;
      } else {
        this.error.uniform.secondary_color = false;
      }

      // validate pants_color
      if (isEmpty(this.uniform.pants_color)) {
        this.error.uniform.pants_color = true;
        validate = false;
      } else {
        this.error.uniform.pants_color = false;
      }

      // validate socks_color
      if (
        isEmpty(this.uniform.socks_color) &&
        this.user.event_sport == "football"
      ) {
        this.error.uniform.socks_color = true;
        validate = false;
      } else {
        this.error.uniform.socks_color = false;
      }

      if (validate) {
        this.dialog2 = false;

        var self = this;

        if (this.uniform.type == "one_colour")
          this.uniform.secondary_color = "";

        // add
        if (this.type == 1) {
          this.$store
            .dispatch("club/addUniform", {
              club_id: self.club.id,
              uniform: self.uniform
            })
            .then(function() {
              self.load();
            });
        }

        // edit
        if (this.type == 2) {
          this.$store
            .dispatch("club/updateUniform", {
              club_id: self.club.id,
              uniform_id: self.uniform.id,
              uniform: self.uniform
            })
            .then(function() {
              self.load();
            });
        }
      }
    }
  }
};
</script>
<style lang="scss">
.v-dialog__content {
  z-index: 99999 !important;
}

#uniforms {
  .v-dialog.v-dialog--active {
    overflow: hidden;
  }

  .subtitle {
    margin: 0;
    font-size: 18px;
    color: #666;
    margin-bottom: 40px;
    font-family: Roboto-Light;
  }
}

#uniform_form {
  height: auto;
  background-color: white;
  padding-bottom: 20px;
  .header {
    h2 {
      text-align: center;
      color: $alert-color;
    }
    img {
      display: block;
      text-align: center;
      margin: 0 auto;
      padding-top: 10px;
      width: 50px;
      height: 50px;
    }
  }
  .buttons {
    text-align: center;
    .button {
      display: inline-block;
      margin: 0 20px;
      padding: 10px;
      width: calc(50% - 40px);
    }
    .delete {
      background-color: $alert-color-bg;
      color: white;
    }
  }
}

#uniform_form {
  position: relative;
  height: auto;
  padding: 0 20px 20px 20px;
  overflow: auto;
  width: 100%;

  .body {
    overflow: auto;
    padding: 15px;
    h2 {
      text-align: center;
      color: black;
      font-family: AvantGarde-Bold;
      font-size: 32px;
    }

    #equipment {
      .uniform {
        margin-top: 75px;
      }
      .uniform,
      .selects {
        width: 50%;
        height: 100%;
        vertical-align: top;
        display: inline-block;
      }
    }
  }
  .buttons {
    width: 100%;
    height: 40px;
    margin-top: 25px;

    .btn {
      width: calc(50% - 20px);
      margin: 0 10px;
      display: inline-block;
      min-width: 40px;
      padding: 0;
      outline: none;
      border: none;
      cursor: pointer;
      text-align: center;
      font-size: 16px;
      border-radius: 3px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      background-color: #172654;
      color: #fff;
      height: 40px;
      line-height: 40px;
      text-transform: uppercase;
      background-color: #fc8926;
      font-family: AvantGarde-Bold;
      max-width: 300px;
      transition: background-color 0.5s ease;

      &#add {
        border: 1px solid #fc8926;

        &:hover {
          background-color: #e78026;
          border-color: #e78026;
        }
      }

      &#cancel {
        background-color: transparent;
        color: #c55c00;
        border: 1px solid #fc8926;

        &:hover {
          background-color: #fc8a2623 !important;
        }
      }
    }
  }
}

#uniforms {
  .row {
    // background-color: #f5f5f5;
    // background-color: $secondary-color;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    height: auto;

    .title {
      display: block;
      width: 100%;
      font-family: AvantGarde-Bold !important;
      color: #222;
    }

    .label,
    .value {
      display: inline-block;
    }
    .label {
      font-weight: bold;
      width: 100px;
    }

    .list-title {
      @include background(
        $image: img("right-arrow.svg"),
        $size: 12px,
        $position: right 6px center
      );
      height: 40px;
      width: 100%;
      display: block;
      padding: 0 20px;
      font-size: 24px;
      line-height: 40px;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: $main-color-t30;
    display: block;
    width: 100%;
    margin: 6px;
  }

  .team-equipment {
    text-align: left;

    .equipment {
      @include display-inline-flex();
      @include justify-content(center);
      @include flex-wrap(wrap);
      width: calc(50% - 20px);
      margin: 0 10px;
      margin-bottom: 15px;
      // width: 18%;
      // margin: 1%;
      display: inline-block;

      .cart {
      }

      .cart,
      .description {
        width: 50%;
        display: inline-block;
      }

      .description {
        vertical-align: top;
        padding: 15px;

        .list {
          color: #999;
          padding: 5px;
        }

        li {
          list-style: square;
        }
      }
    }

    .equip {
      padding: 12px 30px;
      border-radius: 5px 5px 0 0;
      width: 100%;
      border: 2px solid #eee;
      border-bottom: 0;
      margin: 0 auto;
      display: block;
      &.empty {
        opacity: 0.1;
      }
    }
    .uniform-actions {
      background-color: #eee;
      border-radius: 0 0 5px 5px;

      width: 100%;
      height: 40px;
      text-align: center;
      margin: 0 auto;
      display: block;

      .btn {
        @include text-ellipsis();
        width: 50%;
        // min-width: 40px;
        // max-width: 75px;
        height: 100%;
        margin: 0;
        display: inline-block;
        font-size: 17px;
        font-weight: bold;
        font-family: AvantGarde-Bold;
        text-transform: uppercase;

        &:hover {
          //   text-decoration: underline;
          background-color: #fff4d7;
          // color: #fff;
        }
      }
    }
  }

  #add-equipment {
    vertical-align: top;

    .equip {
      cursor: pointer;
      border: 2px dashed #eee;
      border-bottom: 0;
      // position: relative;

      // &:before {
      //   @include background( $image: img('add.svg'), $size: 35px, $color: $main-color );
      //   content: "";
      //   opacity: 1;
      //   width: 65px;
      //   height: 65px;
      //   position: absolute;
      //   z-index: 1;
      //   top: calc( 50% - (65px / 2) );
      //   left: calc( 50% - (65px / 2) );
      //   // border: 2px solid #eee;
      //   border-radius: 10px;
      //   // border-radius: 100%;
      // }

      div {
        opacity: 0.2;
      }
      &:hover {
        background-color: #f5f5f5;
      }
    }
    .uniform-actions {
      background-color: #eee;
      border: 2px dashed #eee;
      border-top: 0;

      .btn {
        width: 100%;
      }
    }
  }

  @include media("<=desktop") {
    // TODO add z-index
    .team-equipment {
      .equipment {
        width: 100%;
      }
    }
  }

  @include media(">phone", "<tablet") {
    .team-equipment {
      .equipment {
        width: 100%;
      }
    }
  }

  @include media(">phone", "<tablet") {
    .v-dialog.v-dialog--active {
      overflow: auto;
    }

    #uniform_form {
      margin: 5px;
      padding: 5px;

      .body {
        overflow: auto;
        #equipment {
          .uniform,
          .selects {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
    }
  }
}
</style>
